export default [
  {
    path: window.pathApp + '/novo-cadastro',
    name: 'cadastro.pessoa.fisica',
    component: () => import('@/components/CadastroPessoaFisica'),
    meta: {
      login: false,
      avisoCarrinho: false,
      title: "Novo Cadastro",
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/pessoa_fisica.js